import { Fonts } from '../constants/fonts';

export const Theme = Object.freeze({
  primary: '#4A2A17',
  background: '#FFF',
  border: "#D9D9D9",
  text: "#000",
  fontFamily: Fonts.Montserrat.Regular,
  fontFamilyBold: Fonts.Montserrat.Bold,
  fontFamilyMedium: Fonts.Montserrat.Medium,
  fontFamilySemiBold: Fonts.Montserrat.SemiBold,
  fontFamilyLight: Fonts.Montserrat.Light,
})
